import type { PlaceholderChunk } from '../helpers/placeholder-layout'

/**
 * Empty-state placeholder — visible any time this shape has been made a text box
 * (`showShapeText` in `shape-manager/components/shape-layer-item.tsx` mounts the editor
 * once `paragraphs != null`, regardless of selection) and is empty, EXCEPT
 * while actively editing: once the caret is blinking and ready for input, the
 * placeholder would just sit on top of it looking like leftover ghost text. Styled
 * with the same red used for the overflow badge/link glyphs
 * (`--color-page-editor-flow-text`) — this codebase's established color for
 * "text-editing-affordance chrome that isn't real content".
 */
export function ShapeTextPlaceholder({
  chunks,
  shapeId,
  rowHeight,
  pointSize,
  fontWeight,
}: {
  chunks: PlaceholderChunk[]
  shapeId: string
  rowHeight: number
  pointSize: number
  fontWeight: number | string
}) {
  return (
    <>
      {chunks.map((chunk, chunkIdx) => (
        <div
          key={`shape-text-placeholder-${shapeId}-${chunkIdx}`}
          className="absolute select-none whitespace-pre pointer-events-none italic"
          style={{
            left: chunk.x,
            top: chunk.yTop,
            lineHeight: `${rowHeight}px`,
            // Fixed, not `cssFamily`: this is UI hint chrome, not a preview of the eventual
            // real text, and must not follow the book/checkpoint default font (or whatever
            // family the user has last applied elsewhere) the way the real seeded run does.
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontSize: `${pointSize}px`,
            fontWeight,
            color: 'var(--color-page-editor-flow-text, #dc2626)',
          }}
        >
          {chunk.text}
        </div>
      ))}
    </>
  )
}
